(function () {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const usTimezones = [
        "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles",
        "America/Phoenix", "America/Anchorage", "America/Adak", "Pacific/Honolulu"
    ];

    if (usTimezones.includes(userTimezone)) {
        const stockistsElement = document.querySelector(".site-nav__item-stockists");
        if (stockistsElement) {
            stockistsElement.classList.remove("hide");
        }
    }
})();